module.exports = __webpack_public_path__ + "img/file-text-outline.png";